import React, { useEffect, useState } from 'react';
import { useTask } from '../context/TaskContext';
import TaskFilter from '../components/tasks/TaskFilter';
import TaskForm from '../components/tasks/TaskForm';
import TaskList from '../components/tasks/TaskList';
import { FaPlus } from 'react-icons/fa';
import './Dashboard.css';

const Dashboard = () => {
  const { getTasks, tasks } = useTask();
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    getTasks();
  }, [getTasks]);

  const taskStats = {
    total: tasks.length,
    todo: tasks.filter(t => t.status === 'todo').length,
    inProgress: tasks.filter(t => t.status === 'in-progress').length,
    completed: tasks.filter(t => t.status === 'completed').length
  };

  return (
    <div className="dashboard">
      <div className="container">
        <div className="dashboard-header">
          <div>
            <h1>My Tasks</h1>
            <p>Organize and manage your tasks efficiently</p>
          </div>
          <button 
            className="btn btn-primary"
            onClick={() => setShowForm(!showForm)}
          >
            <FaPlus /> {showForm ? 'Cancel' : 'New Task'}
          </button>
        </div>

        {/* Stats Cards */}
        <div className="stats-grid">
          <div className="stat-card card">
            <div className="stat-value">{taskStats.total}</div>
            <div className="stat-label">Total Tasks</div>
          </div>
          <div className="stat-card card stat-todo">
            <div className="stat-value">{taskStats.todo}</div>
            <div className="stat-label">To Do</div>
          </div>
          <div className="stat-card card stat-progress">
            <div className="stat-value">{taskStats.inProgress}</div>
            <div className="stat-label">In Progress</div>
          </div>
          <div className="stat-card card stat-completed">
            <div className="stat-value">{taskStats.completed}</div>
            <div className="stat-label">Completed</div>
          </div>
        </div>

        {/* Task Form */}
        {showForm && (
          <div className="fade-in">
            <TaskForm onClose={() => setShowForm(false)} />
          </div>
        )}

        {/* Task Filter */}
        <TaskFilter />

        {/* Task List */}
        <TaskList />
      </div>
    </div>
  );
};

export default Dashboard;
